export { supportManifest, supportPermissions } from "./support-manifest";
